query tipoAgenciaRegionalSelect($where: EnumItemDTOFilterInput) {
    data: tiposAgenciaRegionais(where: $where)  {
        label
        value
    }
}